import FileService, { readFile } from '@services/file.service';
import LoaderService from '@services/loader.service';
import LocalStorageService from '@services/local-storage.service';
import filterPickerList from '@utils/filter-picker-list';
import parseFileString from '@utils/parse-file-string';
import parseLastId from '@utils/parse-last-id';
import parseOptionsList from '@utils/parse-options-list';
import parsePreferences from '@utils/parse-preferences';
import sanitizeDuration from '@utils/validation/duration';
import config from './config';
const { PREFIX } = config;
class Controller {
    sanitizeDuration = sanitizeDuration;
    fileService = new FileService(PREFIX);
    loaderService = new LoaderService();
    storageService = new LocalStorageService(PREFIX);
    getPreferences() {
        return this.storageService.getData('preferences', parsePreferences);
    }
    setPreferences(preferences) {
        this.storageService.saveData('preferences', preferences);
    }
    getOptions() {
        return [this.getOptionsList(), this.getLastOptionId()];
    }
    setOptions([options, lastId]) {
        this.setOptionsList(options);
        this.setLastOptionId(lastId);
    }
    getOptionsList() {
        return this.storageService.getData('optionsList', parseOptionsList);
    }
    setOptionsList(options) {
        this.storageService.saveData('optionsList', options);
    }
    getLastOptionId() {
        return this.storageService.getData('lastId', parseLastId);
    }
    setLastOptionId(id) {
        this.storageService.saveData('lastId', id);
    }
    saveToJSONFile(options, lastId) {
        const extension = 'options.json';
        const type = 'application/json';
        const file = this.fileService.createFile(JSON.stringify({ options, lastId }), type, extension);
        const url = URL.createObjectURL(file);
        this.loaderService.downloadFile(url, file.name);
    }
    async loadFromJSONFile() {
        const file = await this.loaderService.uploadFile();
        if (!file)
            return;
        const result = await readFile(file, parseFileString);
        if (result)
            return result;
    }
    getPickerList() {
        const optionsList = this.getOptionsList();
        const pickerList = filterPickerList(optionsList);
        if (pickerList.length > 1)
            return pickerList;
    }
}
export default new Controller();
